<template>
  <IQOS :title="'Відсоток кешбеку'">
    <p
      class="comment c-white"
    >Для участі в нашій програмі лояльності, погодьтеся з умовами та встановіть відсоток кешбеку для Ваших клієнтів.</p>
    <RoundCheckbox :value="loyalty.terms_agreed" @input="onTermsCheckboxInput">
      <span class="terms-checkbox-text">Я погоджуюсь з умовами програми лояльності</span>
    </RoundCheckbox>
    <div class="cashback-container" v-if="loyalty.terms_agreed">
      <p class="comment c-white">
        Вказаний відсоток вартості чеку буде нараховуватись клієнту на бонусний рахунок.
        При достатній кількості коштів на бонусному рахунку, клієнт може розрахуватись бонусами за замовлення, а сума відповідного чеку буде поповнена на Ваш баланс.
      </p>
      <BlackSelect class="mt-20" v-model="loyalty.cashback_percent" :readonly="!editing">
        <option :value="null" disabled>- Кешбек відсутній -</option>
        <option :value="1">1%</option>
        <option :value="2">2%</option>
        <option :value="3">3%</option>
        <option :value="4">4%</option>
        <option :value="5">5%</option>
      </BlackSelect>
      <p
        class="comment c-grey qrwaiter-cashback"
      >QRWaiter завжди надає клієнту 1% кешбеку від себе (з своїх 3% комісії).</p>
    </div>

    <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" />

    <LoyaltyTermsModal @agree="onTermsAgree" v-if="terms_modal" />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import BlackInput from "@/components/BlackInput.vue";
import BlackSelect from "@/components/BlackSelect.vue";

import RoundCheckbox from "@/components/RoundCheckbox.vue";

import LoyaltyTermsModal from "@/components/loyalty/LoyaltyTermsModal.vue";

export default {
  data() {
    return {
      editing: false,

      loyalty: {
        cashback_percent: null,
        terms_agreed: false
      },

      terms_modal: false
    };
  },
  components: {
    IQOS,
    IQOSActions,
    BlackInput,
    BlackSelect,
    LoyaltyTermsModal,
    RoundCheckbox
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.setInitialValue();
    },
    onEditFinish() {
      if (!this.loyalty.terms_agreed) {
        this.loyalty.cashback_percent = null;
      }
      this.$store.commit("setLoyaltySettings", this.loyalty);
      this.$store.dispatch("saveCafe");

      this.editing = false;
    },
    setInitialValue() {
      if (this.cafe.loyalty) {
        this.loyalty.terms_agreed = this.cafe.loyalty.terms_agreed;
        this.loyalty.cashback_percent = this.cafe.loyalty.cashback_percent;
      }
    },
    onTermsAgree() {
      this.terms_modal = false;
      this.loyalty.terms_agreed = true;
    },
    onTermsCheckboxInput(v) {
      if (!this.editing) return;

      if (v) {
        this.terms_modal = true;
      } else {
        this.loyalty.terms_agreed = false;
      }
    }
  },
  mounted() {
    this.setInitialValue();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    }
  }
};
</script>

<style scoped>
.cashback-input {
  width: 100%;
  margin-top: 1vh;
}

.qrwaiter-cashback {
  margin-top: 1vh;
}

.terms-checkbox-text {
  font-size: 1.8vh;
}

.cashback-container {
  margin-top: 2vh;
}
</style>